const CopyIcon = ({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element => (
  <svg
    width={18}
    height={19}
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.25 14.427v1.024a2.015 2.015 0 01-2.015 2.015h-6.47A2.015 2.015 0 01.75 15.451v-6.47c0-1.113.902-2.015 2.015-2.015h1.024'
      stroke='currentColor'
      strokeWidth={1.5}
    />
    <rect
      x={6.75}
      y={0.966248}
      width={10.5}
      height={10.5}
      rx={2.2069}
      stroke='currentColor'
      strokeWidth={1.5}
    />
  </svg>
)

export default CopyIcon
